<template>
  <el-table-column
    prop="user.full_name"
    label="Létrehozta"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.user.full_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'creator_user',
  };
</script>
